import React from 'react'
import { AddressText, LabelContainer } from './AddressLabel.style'

interface AddressLabelProps {
  address?: string
  hasErrors?: boolean
}

export const AddressLabel = ({ address, hasErrors = false }: AddressLabelProps) => (
  <LabelContainer hasErrors={hasErrors}>
    <AddressText hasErrors={hasErrors} data-testid='address-label-text'>{address}</AddressText>
  </LabelContainer>
)
